import {
	ANALYTICS_HELPER,
	APP_HELPER,
	CONSTANTS,
	HELPER,
	LANG_TRANS,
	MANAGE_CART_HELPER,
} from '../../../utils'
import { alertActions, cartActions } from '../../../store/actions'
import { store } from '../../../store'
import ReactHtmlParser from 'react-html-parser'
import { isMobile } from 'react-device-detect'

function FORMAT_PRODUCT_ARRAY(data) {
	const { categories, products } = data
	let selected_category = {}
	let selected_category_result = {}
	try {
		const list = products.map((product, key) => {
			//selected category older
			selected_category = []
			product.category.map((product_categories) => {
				selected_category_result = categories.find(
					(category) => category.id === product_categories.category_id
				)
				if (HELPER.isNotEmpty(selected_category_result?.name)) {
					selected_category.push(selected_category_result.name)
				} else {
					selected_category.push(LANG_TRANS.en.messages.GENERAL.DEFAULT_CATEGORY_TITLE)
				}
				return true
			})

			const { attribute, active_variants, attribute_option, has_variants } = product

			const attributes = []
			if (has_variants === CONSTANTS.YES && HELPER.isNotEmpty(attribute)) {
				const vaiantOptions = HELPER.groupByList(
					attribute_option,
					(attributeOption) => attributeOption.variant_id
				)
				attribute.forEach(function (attr) {
					attributes.push({
						id: attr.attribute_id,
						name: attr?.attribute_value,
						options: attr?.options,
					})
				})
				active_variants.forEach(function (variant) {
					const variantOptions = vaiantOptions.get(variant.variant_id)
					let variantAttributes = []
					variantOptions.forEach(function (variantOption) {
						const _attr = attribute.find((attr) => {
							return attr.attribute_id === variantOption.attribute_id
						})
						let variantAttribute = { id: _attr.attribute_id, name: _attr.attribute_value }
						const variantAttributeOptions = _attr.options
						variantAttributeOptions.forEach(function (__productOpt) {
							if (variantOption.option_id === __productOpt.option_id) {
								variantAttribute.options = {
									id: __productOpt.option_id,
									attribute_id: __productOpt.attribute_id,
									option_value: __productOpt.option_value,
								}
							}
						})
						variantAttributes.push(variantAttribute)
					})
					variant.attributes = variantAttributes
				})
			}
			return {
				...product,
				attribute: attributes,
				selected_variant: PRODUCT_HELPER.GET_DEFAULT_VARIANT(product),
				selected_category: selected_category,
				key: key + 1,
			}
		})
		/**
		 * RECORD ANALYTICS FOR PRODUCT IMPRESSIONS
		 */
		ANALYTICS_HELPER._productImpressions(list)
		return list
	} catch (error) {
		console.error(error)
		// expected output: ReferenceError: nonExistentFunction is not defined
		// Note - error messages will vary depending on browser
	}
}

function FORMAT_CATEGORIES(list, catalog_journey_settings) {
	const { categories, products } = list
	const defaultCategory = {
		banner: '',
		description: '',
		id: 0,
		is_default: 0,
		name: APP_HELPER.CHECK_LTR_LANG()
			? LANG_TRANS.en.messages.GENERAL.DEFAULT_CATEGORY_TITLE
			: LANG_TRANS.ur.messages.GENERAL.DEFAULT_CATEGORY_TITLE,
		name_ur: 'نیو ارائول',
	}
	categories.unshift(defaultCategory)

	let default_category = categories.find((category) => {
		return category.is_default === CONSTANTS.YES
	})

	const product_in_cart = !HELPER.isEmpty(catalog_journey_settings.product_items)
		? parseInt(catalog_journey_settings.product_items)
		: ''
	let productItem = products.find((product) => {
		return product.id === product_in_cart
	})

	if (!HELPER.isEmpty(productItem) && productItem !== -1 && !HELPER.isEmpty(productItem.category)) {
		if (!HELPER.isEmpty(productItem.category[0].category_id)) {
			productItem.category.map((product_categories) => {
				default_category = categories.find((category) => {
					return category.id === product_categories.category_id
				})
				return true
			})
		} else {
			default_category = categories.find((category) => {
				return category.id === 0
			})
			default_category.is_default = 1
		}
	}

	if (HELPER.isEmpty(default_category)) {
		default_category = categories.find((category) => {
			return category.id === 0
		})
		default_category.is_default = 1
	}

	return { categories, default_category }
}

function FORMAT_PRODUCT_WITH_CATEGORIES(list, catalog_journey_settings) {
	let { products } = list
	let categories = list?.categories?.categories
	let categories_with_products = []
	let selected_default_categories = []

	categories_with_products = categories.map((category) => {
		return {
			category,
			products: [],
		}
	})

	let default_category = categories_with_products.find((categories_with_products) => {
		return categories_with_products.category.is_default === CONSTANTS.YES
	})

	const product_in_cart = !HELPER.isEmpty(catalog_journey_settings.product_items)
		? parseInt(catalog_journey_settings.product_items)
		: ''
	let productItem = products.find((product) => {
		return product.id === product_in_cart
	})
	if (!HELPER.isEmpty(productItem) && productItem !== -1 && !HELPER.isEmpty(productItem.category)) {
		productItem.category.map((product_categories) => {
			selected_default_categories = categories_with_products.find((categories_with_products) => {
				return categories_with_products.category.id === product_categories.category_id
			})
			return true
		})
		if (!HELPER.isEmpty(selected_default_categories)) {
			default_category = selected_default_categories
		}
	}

	// Formatting product categories
	let _categories = ''
	let itemExist = ''
	products.map((product) => {
		if (!HELPER.isEmpty(product.category)) {
			_categories = product.category
			_categories.map((_category) => {
				itemExist = categories_with_products.find((category) => {
					return _category.category_id === category.category.id
				})
				if (itemExist) {
					itemExist.products = HELPER.addObjectToCollection(product, itemExist.products)
				}
				return true
			})
		}
		// product.cat = categories_with_products
		return true
	})

	let all_products = categories_with_products.findIndex((categories_with_products) => {
		return categories_with_products.category.id === 0
	})
	if (all_products !== -1) {
		let updateAllProductsCategory = categories_with_products[all_products]
		updateAllProductsCategory.products = products
		categories_with_products[all_products] = updateAllProductsCategory
	}
	return { categories_with_products, default_category }
}

function DISPLAY_SHORT_DESCRIPTION({ short_description, selected_variant }) {
	let { variant_short_description } = selected_variant
	if (HELPER.isNotEmpty(variant_short_description)) {
		let length = variant_short_description.length
		const readmore = () => {
			document.getElementById('product_description').innerHTML = variant_short_description
			var newElement = document.createElement('span')
			newElement.onclick = hide
			newElement.innerHTML = 'hide'
			newElement.className = 'readmore'
			document.getElementById('product_description').appendChild(newElement)
			document.getElementById('product_description').classList.remove('minified')
			document.getElementById('product_description').classList.add('expanded')
		}
		const hide = () => {
			document.getElementById('product_description').innerHTML = variant_short_description.slice(
				0,
				130
			)
			document.getElementById('product_description').classList.add('minified')
			document.getElementById('product_description').classList.remove('expanded')
			var newElement = document.createElement('span')
			newElement.onclick = readmore
			newElement.innerHTML = 'more'
			newElement.className = 'readmore'
			document.getElementById('product_description').appendChild(newElement)
		}
		return (
			<div className="description minified" id="product_description">
				{length > 130
					? ReactHtmlParser(variant_short_description.slice(0, 130))
					: ReactHtmlParser(variant_short_description)}
				{length > 130 ? (
					<span onClick={readmore} className="readmore">
						more
					</span>
				) : (
					''
				)}
			</div>
		)
	} else if (HELPER.isNotEmpty(short_description)) {
		let length = short_description.length
		const readmore = () => {
			document.getElementById('product_description').innerHTML = short_description
			var newElement = document.createElement('span')
			newElement.onclick = hide
			newElement.innerHTML = 'hide'
			newElement.className = 'readmore'
			document.getElementById('product_description').appendChild(newElement)
			document.getElementById('product_description').classList.remove('minified')
			document.getElementById('product_description').classList.add('expanded')
		}
		const hide = () => {
			document.getElementById('product_description').innerHTML = short_description.slice(0, 130)
			document.getElementById('product_description').classList.add('minified')
			document.getElementById('product_description').classList.remove('expanded')
			var newElement = document.createElement('span')
			newElement.onclick = readmore
			newElement.innerHTML = 'more'
			newElement.className = 'readmore'
			document.getElementById('product_description').appendChild(newElement)
		}
		return (
			<div className="description minified" id="product_description">
				{length > 130
					? ReactHtmlParser(short_description.slice(0, 130))
					: ReactHtmlParser(short_description)}
				{length > 130 ? (
					<span onClick={readmore} className="readmore">
						more
					</span>
				) : (
					''
				)}
			</div>
		)
	}
	return ''
}

function DISPLAY_ADDITIONAL_NOTES(product, detailView = true) {
	const { product_delivery_type, additional_notes } = product
	if (additional_notes && product_delivery_type === CONSTANTS.DELIVERY_TYPE.PURCHASE) {
		const variant_additional_notes = GET_SELECTED_VARIANT(product).additional_notes
		const notes = HELPER.isNotEmpty(variant_additional_notes)
			? variant_additional_notes
			: additional_notes
		return detailView ? (
			<>
				<div className="heading">Additional Notes: </div>
				<div className="notes">{notes}</div>
			</>
		) : (
			notes
		)
	}
	return ''
}

function GET_DEFAULT_VARIANT(product) {
	let { active_variants } = product

	//if no active variant attributes then update active_variant attribute to 0 index
	active_variants = active_variants.map((e1) => ({
		...e1,
		attributes: e1.attributes?.map((e, index) =>
			!e?.options ? { ...e, options: product?.attribute[index]?.options[0] } : e
		),
	}))
	if (HELPER.isNotEmpty(active_variants) && active_variants.length > 0) {
		return active_variants[Object.keys(active_variants)[0]]
	}
}

function FORMAT_PRODUCT_NAME(product) {
	const { name } = product
	return `${HELPER.titleCase(name)}`
}

function FORMAT_PRICE(product) {
	let state = store.getState()
	const { currency_code } = state.config.merchant
	const { price, discounted_price } = GET_SELECTED_VARIANT(product)
	const formattedPrice = HELPER.formatPrice(currency_code, price)
	const discountPrice = HELPER.formatPrice(currency_code, discounted_price)
	if (
		!HELPER.isEmpty(formattedPrice?.charges) &&
		formattedPrice?.charges !== discountPrice?.charges
	) {
		return (
			<span>
				<span>{formattedPrice?.currency}</span> {formattedPrice?.charges}
			</span>
		)
	}
	return ''
}

function FORMAT_DISCOUNTED_PRICE(product) {
	let state = store.getState()
	const { currency_code } = state.config.merchant
	const { price, discounted_price } = GET_SELECTED_VARIANT(product)
	const formattedPrice = HELPER.formatPrice(currency_code, price)
	const discountPrice = HELPER.formatPrice(currency_code, discounted_price)
	if (
		!HELPER.isEmpty(discountPrice?.charges) ||
		formattedPrice?.charges === discountPrice?.charges
	) {
		return (
			<span>
				<span>{discountPrice?.currency}</span> {discountPrice?.charges}
			</span>
		)
	}
	return ''
}

function GET_SELECTED_VARIANT(product) {
	const { selected_variant } = product
	if (HELPER.isNotEmpty(selected_variant) && HELPER.isNotEmpty(selected_variant?.variant_id)) {
		return selected_variant
	}
	return GET_DEFAULT_VARIANT(product)
}

function PRODUCT_IMAGE(product) {
	const { image, id, variant_name } = GET_SELECTED_VARIANT(product)
	return {
		src: image?.url,
		alt: `${id}-${variant_name}`,
	}
}

function PRODUCT_IMAGE_COMPONENT(product) {
	const { variant_name } = product
	const { url, id } = product?.default_image
	return (
		<div>
			<div className="prdMainImg" onClick={() => PRODUCT_HELPER.PRODUCT_SELECTION(product)}>
				<img src={url} alt={`${id}-${variant_name}`} />
			</div>
			{PRODUCT_HELPER.PRODUCT_IMAGE_BOX_ACTIONS(product)}
		</div>
	)
}

function PRODUCT_MAX_QUANTITY(product) {
	if (HELPER.isNotEmpty(product)) {
		const { max_quantity, track_quantity } = GET_SELECTED_VARIANT(product)
		return track_quantity === 0
			? product?.max_quantity
			: max_quantity > product?.max_quantity
			? product?.max_quantity
			: max_quantity
	} else {
		const { max_quantity } = store.getState().inventory.inventory_settings
		return max_quantity
	}
}

function PRODUCT_IMAGE_BOX_ACTIONS(product) {
	const { active_variants, has_variants } = product
	let state = store.getState()
	const { translate } = state.meta.translation
	const cart_itemList = state.cart.cart_items.items
	const itemExist = cart_itemList.findIndex((item) => {
		return item.product.id === product.id
	})
	const variantCount = active_variants.length
	const ADDED_TO_CART_BTN = (
		<button className="addToCartBtn addedToCartBtn">
			<span>{translate('CART.ADDED')} </span>
		</button>
	)
	const ADD_TO_CART_ICON = (
		<button
			className="addToCartBtn"
			onClick={() => {
				if (variantCount <= 1) {
					PRODUCT_HELPER.ADD_PRODUCT_TO_CART(product)
				} else {
					PRODUCT_HELPER.PRODUCT_SELECTION(product)
				}
			}}
		>
			{variantCount > 1 && has_variants === 1 ? (
				<i className="icons-icon-more"></i>
			) : (
				<i className="icons-icon-cart"></i>
			)}
		</button>
	)
	return itemExist === -1 ? ADD_TO_CART_ICON : ADDED_TO_CART_BTN
}

const ADD_PRODUCT_TO_CART = (
	product,
	operation = CONSTANTS.ADD_QTY,
	quantity = 1,
	maximum_purchase_limit,
	show_msg = true
) => {
	let state = store.getState()
	const { cart_items } = state.cart
	const cardItem = cart_items.items
	let addedItem = cardItem.findIndex((item) => {
		return (
			item.product.id === product.id &&
			item.product.selected_variant.variant_id === product.selected_variant.variant_id
		)
	})
	const max_quantity = PRODUCT_HELPER.PRODUCT_MAX_QUANTITY(product)
	if (addedItem === -1) {
		if (HELPER.isEmpty(product?.selected_variant?.variant_id)) {
			product.selected_variant = PRODUCT_HELPER.GET_DEFAULT_VARIANT(product)
		}
		store.dispatch(
			cartActions.ADD_ITEM_TO_CART(product, quantity, maximum_purchase_limit, show_msg)
		)
	} else if (cardItem[addedItem].qty <= max_quantity) {
		store.dispatch(cartActions.UPDATE_ITEM_QTY_TO_CART(cart_items, product, operation, quantity))
	} else {
		MANAGE_CART_HELPER.MaxQuantityReached(product)
	}
}

const FIND_PRODUCT_VARIANT = (product, variant_id) => {
	const { active_variants } = product
	product.selected_variant = active_variants.find(function (variant) {
		return variant_id === variant?.variant_id
	})
	return product
}

const UPDATE_CART_LANG = (cart_items) => {
	let state = store.getState()
	const { allProducts } = state.inventory
	const { items } = cart_items
	items.map((item) => {
		allProducts.find((product) => {
			if (item?.product?.id === parseInt(product.id)) {
				item.product = FIND_PRODUCT_VARIANT(item?.product, item?.variant_id)
			}
			return true
		})
		return true
	})
	return items
}

const PRODUCT_SELECTION = (product) => {
	ANALYTICS_HELPER._productClick(product)
	if (HELPER.isEmpty(product?.selected_variant?.variant_id)) {
		const selected_variant = GET_SELECTED_VARIANT(product)
		product = { ...product, selected_variant }
	}
	store.dispatch(cartActions.SELECT_PRODUCT_ITEM(product))
}

const BUY_NOW = (product) => {
	//get qty from cart items
	const state = store.getState()
	const { cart_items } = state.cart
	const { showProductDetail } = state.action
	if (cart_items?.count > 0) {
		const cardItems = cart_items.items
		let addedItem = cardItems.findIndex((item) => {
			return (
				item.product.id === product.id &&
				item.product.selected_variant.variant_id === product.selected_variant.variant_id
			)
		})
		if (addedItem === -1) {
			let cardItem = cart_items?.items?.find((e) => e.product?.id === product.id)
			let qty = !HELPER.isEmpty(cardItem) ? cardItem.qty : 1
			PRODUCT_HELPER.ADD_PRODUCT_TO_CART(product, CONSTANTS.ADD_QTY, qty, false, false)
			store.dispatch(cartActions.UPDATE_CART(product))
			store.dispatch(cartActions.REMOVE_CART_ITEMS_FROM_CART(addedItem))
		}
	} else {
		let cardItem = cart_items?.items?.find((e) => e.product?.id === product.id)
		let qty = !HELPER.isEmpty(cardItem) ? cardItem.qty : 1
		PRODUCT_HELPER.ADD_PRODUCT_TO_CART(product, CONSTANTS.ADD_QTY, qty, false, false)
		store.dispatch(cartActions.UPDATE_CART())
		store.dispatch(cartActions.REMOVE_CART_ITEMS_FROM_CART(cardItem))
	}
	store.dispatch(cartActions.PRODUCT_BUY_NOW_CLICKED())
	if (!showProductDetail || isMobile) {
		store.dispatch(cartActions.REMOVE_CART_ITEMS_FROM_CART(product))
	}
	PRODUCT_HELPER.PROCEED_TO_CHECKOUT()
}

const PROCEED_TO_CHECKOUT = () => {
	let state = store.getState()
	const { locale } = state.Intl
	const { store_slug } = state.config.merchant
	const { cart_items } = state.cart
	const { count } = state.cart.cart_items
	const { translate } = state.meta.translation

	if (count > 0 && !HELPER.isEmpty(store_slug) && !HELPER.isEmpty(cart_items?.items)) {
		store.dispatch(
			cartActions.CREATE_ORDER({
				store_id: store_slug,
				cart_items,
				customer: {},
				lang: locale,
			})
		)
	} else {
		store.dispatch(
			alertActions.warning(translate('GENERAL.EMPTY_CART'), CONSTANTS.ERROR_TYPE.TOAST, true)
		)
	}
}

const PRODUCT_HELPER = {
	ADD_PRODUCT_TO_CART,
	BUY_NOW,
	DISPLAY_SHORT_DESCRIPTION,
	DISPLAY_ADDITIONAL_NOTES,
	FORMAT_PRODUCT_NAME,
	FORMAT_PRICE,
	FORMAT_DISCOUNTED_PRICE,
	FORMAT_PRODUCT_ARRAY,
	FORMAT_CATEGORIES,
	FORMAT_PRODUCT_WITH_CATEGORIES,
	GET_DEFAULT_VARIANT,
	GET_SELECTED_VARIANT,
	PRODUCT_SELECTION,
	PRODUCT_IMAGE,
	PRODUCT_IMAGE_COMPONENT,
	PRODUCT_IMAGE_BOX_ACTIONS,
	PROCEED_TO_CHECKOUT,
	UPDATE_CART_LANG,
	FIND_PRODUCT_VARIANT,
	PRODUCT_MAX_QUANTITY,
}
export default PRODUCT_HELPER
